<div class="w-full flex h-1 shadow bg-primary-200 shadow-inner">
	<div class="bg-primary-500 z-10 transition-all duration-500" [style.width.%]="filled" [class.rounded-r-sm]="filled < 100" [class.rounded-none]="filled === 100"></div>
</div>
